// Libraries
import React, { Component } from 'react'
import I18n from 'i18next'
import { get } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Components
import { Container } from 'Components/Modals'

// Styles
import './DeleteModal.less'

const mode = 'single'

class DeleteModal extends Component {
  static propTypes = {
    // Labels et titres
    title: PropTypes.object,
    okText: PropTypes.object,
    cancelText: PropTypes.object,
    content: PropTypes.object,

    // Contrôle d'état de la modale
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    visible: PropTypes.bool,
    loading: PropTypes.bool,

    onOk: PropTypes.func,
    onCancel: PropTypes.func
  }

  static defaultProps = {
    // Actions d'API
    actions: {},

    // Labels et titres
    title: {
      single: 'pages.permits.modal.delete.single.title'
    },
    okText: {
      single: 'pages.permits.modal.delete.single.okText'
    },
    cancelText: {
      single: 'pages.permits.modal.delete.single.cancelText'
    },
    content: {
      single: 'pages.permits.modal.delete.single.content'
    },

    // Contrôle d'état de la modale
    width: 520,
    visible: false,
    loading: true
  }

  render() {
    const {
      onOk,
      onCancel,
      width,
      title,
      okText,
      content,
      loading,
      visible,
      cancelText
    } = this.props

    return (
      <Container
        title={I18n.t(get(title, mode))}
        loading={loading}
        visible={visible}
        cancelText={I18n.t(get(cancelText, mode))}
        okText={I18n.t(get(okText, mode))}
        onOk={onOk}
        onCancel={onCancel}
        className={'modal delete-modal'}
        width={width}
      >
        <div>{I18n.t(get(content, mode))}</div>
      </Container>
    )
  }
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteModal)
